export enum EnumOperator {
    DifferentFrom,
    Equals,
    MoreThan,
    LessThan
}
export class FieldValidator {
  public model: string;
  public object : any; 
  public component: any;
  public element: string;
  public condition: boolean;
  public operator?: EnumOperator;
  public checkValue?: any;
  constructor(_model: string, _object: any, _component: any, _element: string, _condition: boolean, _operator?: EnumOperator, _checkValue?: any) {
    this.model = _model;       
    this.object = _object;
    this.component = _component;
    this.element = _element;
    this.condition = _condition;
    this.operator = _operator;
    if (this.operator == EnumOperator.DifferentFrom || this.operator == EnumOperator.Equals) {
      if (!Array.isArray(_checkValue))
        throw 'La propiedad checkValue debe ser de tipo Array'
    }
    if (this.operator == EnumOperator.MoreThan || this.operator == EnumOperator.LessThan) {
      if (typeof(_checkValue) !== 'number')
        throw 'La propiedad checkValue debe ser de tipo Number'
    }
    this.checkValue = _checkValue;
  }
} 